<template>
  <div class="mask" data-range="mask" @click="closeRule">
    <div class="drawRule">
      <h2 class="title">
        {{ controlInfo.popupTitle }}
      </h2>
      <p class="text" v-html="controlInfo.ruleContent"></p>
    </div>
  </div>
</template>
<script setup>
  const emit = defineEmits(['closeRule'])
  const prop = defineProps({
    controlInfo: {
      type: Object,
      default: () => {}
    }
  })
  const closeRule = (e) => {
    const range = e.target.dataset.range
    if(range) {
      emit('closeRule')
    }
  }
</script>
<style scoped lang="scss">
.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.85);
  .drawRule {
    width: 92%;
    max-width: 525px;
    min-height: 320px;
    background: #FFFFFF;
    border-radius: 20px;background: linear-gradient(180deg, #C6E7FF 0%, #5FC1FF 100%);
    border: 2px solid #FFFFFF;
    box-shadow: 0px 4px 20px 0px #FFFFFFCC;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-top: 70px;
    .text {
      font-size: 24px;
      color: #003C64;
      line-height: 35px;
      padding: 0 12px;
      max-height: 50vh;
      overflow: hidden;
      overflow-y: auto;
      /* 针对 Firefox 浏览器 */
      scrollbar-width: none;
      /* 针对 IE 和 Edge 浏览器 */
      -ms-overflow-style: none;
      /* 针对 Chrome、Safari 和 Opera 浏览器 */
      ::-webkit-scrollbar {
        display: none; /* 完全隐藏滚动条 */
      }
    }
  }
}
:deep(img) {
  max-width: 100%;
}
.title {
  width: 405px;
  height: 74px;
  background: url("@/assets/images/bg-title-btn.png") center center no-repeat;
  background-size: 100% 100%;
  text-align: center;
  line-height: 74px;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
}
@media screen and (max-width: 768px) {
  .title {
    width: 218px;
    height: 38px;
    line-height: 38px;
    top: -12px;
    font-size: 16px;
  }
}
</style>
